import { useContext } from 'react';
import { Col, Row } from "react-bootstrap";
import { SecondaryGreenButton } from '../../../Buttons/styles';
import { AddImageModalContext } from '../context/AddImageModalContext';

export function SendFileScreen() {
    const {
        handleAddFileButton, isInvalidVideoInput, errorMessage, imageObject
    } = useContext(AddImageModalContext);

    return <>
        {imageObject.ImageUrl === "" ?
            (
                <>
                    {isInvalidVideoInput ?
                        (
                            <Row className='mb-3'>
                                <Col className="erro-message mx-auto py-2">
                                    <Row>
                                        <Col md="auto" className="my-auto pr-0">
                                            <i className='bi bi-exclamation-octagon' />
                                        </Col>
                                        <Col className="my-auto">
                                            <p>
                                                {errorMessage}
                                            </p>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        )
                        :
                        (
                            <></>
                        )}

                    <Row>
                        <SecondaryGreenButton className="w-100" onClick={handleAddFileButton}>
                            <Row className='my-1'>
                                <Col md="auto" className="ml-auto my-auto pr-0">
                                    <i className="bi bi-files" />
                                </Col>
                                <Col md={7} className="text-left">
                                    <p>
                                        Escolher Arquivo
                                    </p>
                                </Col>
                            </Row>
                        </SecondaryGreenButton>
                    </Row>
                    <Row className='mt-3'>
                        <Col>
                            <p>
                                São aceitos arquivos nos formatos .jpg, .jpeg e .png, com tamanho de até 100MB.
                            </p>
                        </Col>
                    </Row>

                </>
            )
            :
            (
                <>
                    {isInvalidVideoInput ?
                        (
                            <Row className='mb-3'>
                                <Col className="erro-message mx-auto py-2">
                                    <Row>
                                        <Col md="auto" className="my-auto pr-0">
                                            <i className='bi bi-exclamation-octagon' />
                                        </Col>
                                        <Col className="my-auto">
                                            <p>
                                                {errorMessage}
                                            </p>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        )
                        :
                        (
                            <></>
                        )}

                    <Row className="mt-3 mb-4">
                        <Col className='my-auto ml-5'>
                            <p>
                                {imageObject.ImageName}
                            </p>
                        </Col>
                    </Row>
                    <Row className="">
                        <Col md="auto" className='mx-auto mt-4'>
                            <img src={imageObject.ImageUrl}>
                            </img>
                        </Col>
                    </Row>
                </>
            )}
    </>;
}
